import ApiResourceManager from '../ApiResourceManager';

/**
 * A destination partner's Stripe processing-fee rate book. Without a company the
 * endpoint reads and writes the partner's default; with one, that restaurant's
 * override. useApiClient stamps x-on-behalf-of-company with the selected
 * restaurant on every request, so the header is always sent explicitly here: an
 * empty one is what the backend reads as the partner scope.
 */
const scopeHeaders = (companyId) => ({ 'x-on-behalf-of-company': companyId ?? '' });

export default class StripeProcessingFeeRatesManager extends ApiResourceManager {
  get = (companyId = null) =>
    this.request({
      method: 'GET',
      url: '/stripe-processing-fee-rates',
      headers: scopeHeaders(companyId),
    });

  /** Replaces the whole book; null clears it (restaurant: inherit the default, partner: 0% margin). */
  update = (rates, companyId = null) =>
    this.request({
      method: 'PUT',
      url: '/stripe-processing-fee-rates',
      data: { rates },
      headers: scopeHeaders(companyId),
    });

  /** The partner's consent to charge no Stripe processing fee and pay Stripe's fee itself. */
  consentToZeroMargin = () =>
    this.request({
      method: 'PUT',
      url: '/stripe-processing-fee-consent',
      headers: scopeHeaders(null),
    });

  withdrawZeroMarginConsent = () =>
    this.request({
      method: 'DELETE',
      url: '/stripe-processing-fee-consent',
      headers: scopeHeaders(null),
    });
}
